<template>
  <FCPWrapper>
    <BaseAdvancedTable
      :actions="[]"
      :fields="fields"
      :items="items"
      :busy="isBusy"
      :sort-desc="false"
      sort-by="age"
      :fitTableBodyToWindow="fitTableBodyToWindow"
    >
      <template #cell(UMR)="{ data: { value, item } }"
        ><b-icon
          v-if="'Pending' === item.status"
          icon="clock-history"
          class="mr-2"
        ></b-icon
        >{{ value }}</template
      >

      <template #cell(uploaded_on)="{ data: { value } }">{{
        moment(value).format("MM/DD/YYYY hh:mm A")
      }}</template>

      <template #cell(link)="{ data: { item } }">
        <router-link
          v-if="item.uploaded_file_id"
          :to="{
            name: 'FCPLogPreview',
            params: {
              uniqueId: item.uploaded_file_id,
              fileName: item.filename,
            },
          }"
          >View File</router-link
        >
        <template v-else>N/A</template>
      </template>
    </BaseAdvancedTable>
  </FCPWrapper>
</template>

<script>
import Vue from "vue";
import { defineComponent, reactive, ref, onMounted } from "@vue/composition-api";
import moment from "moment";

import { useAuth } from "@composables/auth";
import { FCPUpload } from "@services";

import FCPWrapper from "@components/FCP/FCPWrapper.vue";

import { default as fields } from "./utils/logsTableFields";

export default defineComponent({
  name: "FCPLogsTable",
  props: {
    fitTableBodyToWindow: {
      type: Boolean,
      description: "Fits the table body to the page while preserving sticky header",
      default: false,
    },
  },
  components: {
    FCPWrapper,
  },
  setup() {
    const { currentUser } = useAuth();

    const viewLinkBase = process.env.VUE_APP_LINCOLN_URL;

    const isBusy = ref(true);
    const items = ref([]);

    const pagination = reactive({
      currentPage: 1,
      perPage: 100,
    });

    const fetchItems = async () => {
      isBusy.value = true;

      const {
        data: {
          data: { results, next },
        },
      } = await FCPUpload.getFCPUploads({
        ...(!currentUser.value.is_superuser ? { user_id: currentUser.value.id } : null),
        page: pagination.currentPage,
        page_size: pagination.perPage,
      })
        .catch((err) => Promise.reject(err))
        .finally(() => (isBusy.value = false));

      items.value = items.value.concat(results);

      if (next) {
        pagination.currentPage += 1;

        fetchItems();
      }
    };

    onMounted(fetchItems);

    Vue.prototype.$emitter.on("files-uploaded", ({ type }) => {
      if ("fcp" !== type) return;

      items.value = [];

      fetchItems();
    });

    return {
      moment,
      viewLinkBase,
      fields,
      items,
      isBusy,
    };
  },
});
</script>
